import React, {
	Component
} from 'react';
import {
	Button,
	Form,
	Row,
	Col
} from 'antd';
import {
	WeaFormItem,
	WeaNewScroll,
	WeaSearchGroup,
} from 'ecCom';
import {
	WeaSwitch
} from 'comsMobx';
import _ from 'lodash';

export default class AdvanceSearchFormInfo extends Component {
	renderForm = () => {
		const {
			form,
			formFields,
			itemRender
		} = this.props;
		let arr = [];
		let formParams = form.getFormParams();
		formFields.map(c => {
			let _arr = [];
			c.items.map((field, index) => {
				const customerRender = itemRender != null ? itemRender[field.domkey[0]] : null;
				const itemProps = {
					ratio1to2: true,
					label: field.label,
					labelCol: {
						span: `${window.HrmEngineLabelCol}`
					},
					error: form.getError(field),
					tipPosition: 'bottom',
					wrapperCol: {
						span: `${window.HrmEngineWrapperCol}`
					}
				}
				let coms;
				if (customerRender == null) {
					coms = <WeaSwitch fieldConfig={field} form={form}/>;
				} else {
					coms = customerRender(field, form, formParams);
				}
				coms != null && _arr.push(
					(
						<Col span={11} offset={index % 2 === 0 ? 1 : 0}>
							<WeaFormItem
								ratio1to2
			                    label={`${field.label}`}
			                    labelCol={{span: `${window.HrmEngineLabelCol}`}}
			                    error={form.getError(field)}
			                    tipPosition={'bottom'}
			                    wrapperCol={{span: `${window.HrmEngineWrapperCol}`}}
			                 >
			                     {coms}
			                 </WeaFormItem>
		                </Col>
					)
				)
				if (_arr.length === 2 || index === c.items.length - 1) {
					const clone = [..._arr];
					_arr.length = 0;
					arr.push(<Row gutter={8} style={{marginTop: '10px'}}>{clone}</Row>);
				}
			})
		})
		return <Form>{arr}</Form>;
	}

	renderGroupForm = () => {
		const {
			form,
			formFields,
			itemRender
		} = this.props;
		let formParams = form.getFormParams();
		let arr = [];
		formFields.map(c => {
			let _arr = [];
			c.items.map((field, index) => {
				const customerRender = itemRender != null ? itemRender[field.domkey[0]] : null;
				const itemProps = {
					ratio1to2: true,
					label: field.label,
					labelCol: {
						span: `${window.HrmEngineLabelCol}`
					},
					error: form.getError(field),
					tipPosition: 'bottom',
					wrapperCol: {
						span: `${window.HrmEngineWrapperCol}`
					}
				}
				let coms;
				if (customerRender == null) {
					coms = <WeaSwitch fieldConfig={field} form={form}/>;
				} else {
					coms = customerRender(field, form, formParams);
				}
				coms != null && _arr.push({
					com: (
						<WeaFormItem
								ratio1to2
                                label={`${field.label}`}
                                labelCol={{span: `${window.HrmEngineLabelCol}`}}
                                error={form.getError(field)}
                                wrapperCol={{span: `${window.HrmEngineWrapperCol}`}}
                        >
                            {coms}
                        </WeaFormItem>
					),
					col: field.colSpan || 2
				})
			})
			arr.push(<WeaSearchGroup showGroup={c.defaultshow} items={_arr} fontSize={13}/>);
		})
		return arr;
	}

	renderFormComponent = () => {
		const {
			formFields
		} = this.props;

		const com = formFields.length > 1 ? this.renderGroupForm() : this.renderForm();
		return com;
	}

	render() {
		return (
			<WeaNewScroll height={'100%'}>
			{this.renderGroupForm()}
			</WeaNewScroll>
		)
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/coms/AdvanceSearchFormInfo.js